/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description utils for parsing FHIR data types
 */

import _ from 'lodash';
import { CLAIM_STATUS_CODING_SYSTEMS } from 'utils/claims/fhir';

// get identifier value using system
const getIdentifierValue = (identifierList: Fhir.Identifier[], system: string): string | undefined => {
	return _.find(identifierList, { system })?.value;
};

// get human name
const getHumanName = (names: Fhir.HumanName[]): string => {
	const firstItem = _.first(names);
	if (firstItem?.text) {
		return firstItem?.text;
	}
	const firstName = _.join(_.compact(firstItem?.given), ' ');
	const lastName = firstItem?.family || '';
	if (!firstName && !lastName) {
		return '';
	}
	return _.join(_.compact([firstName, lastName]), ' ');
};

// get name
const getName = (resource: AnyType): string => {
	return _.isString(resource?.name) ? resource?.name : getHumanName(resource?.name);
};

const getFhirClaimStatus = (resource: AnyType): string => {
	const statusCodings = _.filter(resource?.coding ?? [], (coding) => _.includes(CLAIM_STATUS_CODING_SYSTEMS, coding?.system));
	return _.first(statusCodings)?.code;
};

const getClaimStatus = (resource: AnyType): string => {
	return _.isString(resource?.status) ? resource?.status : getFhirClaimStatus(resource);
};

export { getIdentifierValue, getName, getClaimStatus };
